// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-notice-period-data-restriction.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-notice-period-data-restriction',
  title: 'Restrict copying of critical and sensitive information during employee notice periods',
  description:
    "During the notice or transition period following resignation or termination, employees' ability to copy critical or sensitive information must be restricted to the absolute minimum. Technical controls (DLP, access restriction) or procedural controls must be applied for the duration of the notice period.",
  category: 'people',
  scfIds: ['SCF-DAT-003', 'SCF-PPL-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Notice-period data restriction procedure is documented',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
